import { StateCreator } from "zustand";

type PersonalInfo = {
    name: string;
    surname: string;
    email: string;
    identityNumber: string;
    phone: string;
    city: string;
    address: string;
    toc: boolean;
};

type PersonalInfoSlice = {
    personalInfo: PersonalInfo;
    setPersonalInfo: (data: PersonalInfo) => void;
};

const initialState: PersonalInfo = {
    name: "",
    surname: "",
    email: "",
    identityNumber: "",
    phone: "",
    city: "",
    address: "",
    toc: false,
};

const createPersonalInfoSlice: StateCreator<PersonalInfoSlice> = (set) => ({
    personalInfo: initialState,
    setPersonalInfo: (data) =>
        set((state) => ({ personalInfo: { ...state.personalInfo, ...data } })),
});

export default createPersonalInfoSlice;
export type { PersonalInfoSlice };
